import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
  NgZone,
} from '@angular/core';
import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts';

import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
} from 'ng-apexcharts';
import {
  DonutChartItem,
  DonutChartModel,
} from 'src/app/features/graphs/model/donut-chart/donut-chart-model';
import { ChartOptions } from 'src/app/features/graphs/model/donut-chart/chart-options';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-donut-chart',
  templateUrl: 'donut-chart.component.html',
  styleUrls: ['donut-chart.component.scss'],
  standalone: true,
  imports: [CommonModule, NgApexchartsModule],
})
export class DonutChartComponent implements OnInit, OnChanges {
  @Input() data: DonutChartModel;

  @ViewChild('chart', { read: ElementRef }) chart: ElementRef;
  public chartOptions: Partial<ChartOptions>;

  hoveredItem: DonutChartItem | null = null;
  seriesItems: DonutChartItem[] = [];

  isDataAvailable: boolean = false;
  ticks = Array.from({ length: 101 }, (_, i) => i); // 0 to 100
  radius = 90;

  constructor(private zone: NgZone) {}

  ngOnInit() {
    this.initializeChart();
  }

  ngOnChanges() {
    this.initializeChart();
  }

  getAngle(i: number): number {
    return (i / 100) * 180 + 180;
  }

  getX(i: number, r: number): number {
    const angle = (this.getAngle(i) * Math.PI) / 180;
    return r * Math.cos(angle);
  }

  getY(i: number, r: number): number {
    const angle = (this.getAngle(i) * Math.PI) / 180;
    return r * Math.sin(angle);
  }

  private initializeChart() {
    this.isDataAvailable = false;
    this.hoveredItem = null;
    this.chartOptions = this.getDefaultChartOptions();
    this.seriesItems = []

    if (!this.data || !this.data?.items || this.data?.items?.length === 0) {
      this.chartOptions.series = [];
      this.chartOptions.labels = [];
      return;
    }

    this.isDataAvailable = true;

    for (let i = 0; i < this.data.items.length; i++) {
      const item: DonutChartItem = this.data.items[i];
      if (item.label === 'Pases totales') {
        continue;
      }
      if (this.hoveredItem == null) {
        this.hoveredItem = item;
      }
      this.seriesItems.push(item);
      this.chartOptions.labels.push(item.label);
      this.chartOptions.series.push(item.value);
      this.chartOptions.colors.push(item.color);
    }
  }

  private getDefaultChartOptions(): ChartOptions {
    return {
      title: {
        text: this.data?.title || 'No data provided',
      },
      labels: [],
      series: [],
      colors: [],
      dataLabels: {
        enabled: false,
      },
      chart: {
        type: 'donut',
        events: {
          dataPointMouseEnter: (event, chartContext, config) => {
            const index = config.dataPointIndex;
            const item = this.seriesItems[index] || null;
            this.zone.run(() => {
              this.hoveredItem = item || null;
            });
          },
        },
      },
      legend: {
        show: false,
      },
      tooltip: {
        enabled: true,
        style: {
          fontSize: '1em',
          fontFamily: 'RFEBM',
        },
      },
      options: {
        stroke: {
          lineCap: 'round',
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 90,
            donut: {
              size: '85%',
            },
          },
        },
      },
      responsive: [
        {
          options: {
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    };
  }
}
